import React from "react";
import {
  Breadcrumb,
  Callout,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IDropdownOption,
  PrimaryButton,
  SelectionMode,
  Stack,
  Text,
} from "@fluentui/react";
import { mdiDotsVertical } from "@mdi/js";
import { useHistory, useParams } from "react-router-dom";
import { getAllDataCentersOfCustomer } from "../../../services/datacenter/DatacenterService";
import { IServiceDetails } from "../../../vm";
import { childrenGap, childrenGap8 } from "../../common/Constants";
import NoDataTile from "../../common/NoDataTile";
import Icon from "@mdi/react";
import {
  deleteServiceDetails,
  getAllCustomers,
  getServiceDetails,
} from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import ManageSdDialog from "./ManageSdDialog";
import moment from "moment";
import { Loading } from "../../../services/Loading";
import { parseJwt } from "../../../services/UtilService";
import TotalNumbers from "../../common/TotalNumbers";

var datacenterDict: any = {};

export interface ServiceDetailsProps { }

const ServiceDetails: React.FC<ServiceDetailsProps> = () => {
  // custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    serviceDetails: [],
    allDatacenterDropdown: [],
    searchObj: {
      customerId: params.customerId,
    },
    manageAcDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    serviceDetails: IServiceDetails[];
    allDatacenterDropdown: IDropdownOption[];
    searchObj: {
      customerId: string;
      datacenterId?: string;
    };
    manageAcDialog: {
      isOpen: boolean;
      index?: number;
      data?: IServiceDetails;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IServiceDetails;
    };
  });

  const [customer, setCustomer] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
  } as {
    isLoading: boolean;
    customer: any;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await searchDataCenters();
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setCustomer({ ...customer, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result?.success) {
      setCustomer({
        ...customer,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setCustomer({ ...customer, isLoading: false });
    }
  };

  const searchDataCenters = async () => {
    setState({ ...state, isLoading: false });

    let result = await getAllDataCentersOfCustomer(params.customerId);
    if (result?.success) {
      let allDatacenterDropdown: IDropdownOption[] = [];
      result.data.forEach((item) => {
        allDatacenterDropdown.push({
          key: item._id as string,
          text: item.name,
        });
      });

      datacenterDict = result.data.reduce((acc: any, d) => {
        acc[d._id as string] = d.name;
        return acc;
      }, {});
      // console.log("datacen", datacenterDict);

      let obj = {
        ...state,
        allDatacenterDropdown,
        datacenterDict,
        isLoading: false,
      };
      setState(obj);
      getAllServiceDetails("", obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting all datacenters",
        "error"
      );
    }
  };

  const getAllServiceDetails = async (
    datacenterId?: string,
    paramState?: any
  ) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
    }
    setState({ ...state, isLoading: true });
    let searchObj = { ...localState.searchObj };
    if (datacenterId) {
      searchObj.datacenterId = datacenterId;
    }
    let result = await getServiceDetails(searchObj);
    if (result?.success) {
      setState({
        ...localState,
        serviceDetails: result.data,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting service details",
        "error"
      );
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let serviceDetails = undefined;
    if (index !== undefined) {
      serviceDetails = { ...state.serviceDetails[index] };
    }
    setState({
      ...state,
      manageAcDialog: {
        isOpen,
        index,
        data: serviceDetails,
      },
    });
  };

  const handleDialogClose = (data: IServiceDetails) => {
    let serviceDetails = [...state.serviceDetails];
    if (data) {
      if (state.manageAcDialog.index !== undefined) {
        serviceDetails[state.manageAcDialog.index] = data;
        showToast("Service Details updated successfully", "success");
      } else {
        serviceDetails.push(data);
        showToast("Service Details added successfully", "success");
      }
    }
    setState({
      ...state,
      manageAcDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      serviceDetails,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deleteSd = async (item: IServiceDetails, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete service details",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteServiceDetails(item);
        if (result?.success) {
          showToast("Service Details deleted successfully", "success");
          let serviceDetails = [...state.serviceDetails];
          serviceDetails.splice(index, 1);
          setState({
            ...state,
            serviceDetails,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting service details",
            "error"
          );
        }
      }
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            // onClick={
            //   state.allDatacenterDropdown.length * 2 - 1 >= index
            //     ? undefined
            //     : (ele) => handleCallOutOpenClose(true, ele, index, item)
            // }
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className={"pointer"}
              color={"#135c8a"}
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={`Edit Service Details`}
          //     id={`editEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={`Delete Service Details`}
          //     id={`deleteEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteSd(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );

      case "commissionDate":
        return <span>{moment(item.commissionDate).format("DD/MM/YYYY")}</span>;
      case "datacenterId":
        return <span>{datacenterDict[item.datacenterId]}</span>;
      case "orderId":
        return (
          <Text style={{ fontWeight: 600 }}>
            {item[column.fieldName as any]}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const onSearch = async () => {
    await getAllServiceDetails();
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IServiceDetails
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {(state.isLoading || customer.isLoading) && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: customer.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${customer.customer._id}`);
                },
              },
              {
                text: "Service Details",
                key: "service-details",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
            verticalAlign="center"
          >
            <Stack.Item>
              <TotalNumbers value={state.serviceDetails.length} />
              {/* <Stack
                horizontal
                wrap
                tokens={childrenGap}
                horizontalAlign="start"
              > */}
              {/* <Stack.Item>
                  <Dropdown
                    placeholder="Select a Datacenter"
                    selectedKey={state.searchObj.datacenterId}
                    styles={{ dropdown: { width: 250 } }}
                    options={state.allDatacenterDropdown}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        // let options: IDropdownOption[] = [
                        //   { key: "all", text: "All" } ]
                        // ;
                        // let allDatacenterDropdown = [
                        //   ...state.allDatacenterDropdown,
                        // ];
                        // allDatacenterDropdown = [ ...options, allDatacenterDropdown]
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            datacenterId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={onSearch} />
                </Stack.Item> */}
              {/* </Stack> */}
            </Stack.Item>
            {![4].includes(tokenData.role) && (
              <Stack.Item>
                <PrimaryButton
                  text="Add Service Details"
                  onClick={() => handleDialogOpen(true)}
                  className="borderless-btn bg-white"
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.serviceDetails && state.serviceDetails.length > 0 ? (
            <Fabric>
              <DetailsList
                items={state.serviceDetails}
                columns={
                  ![4].includes(tokenData.role)
                    ? [
                      {
                        key: "orderId",
                        name: "Order Id",
                        fieldName: "orderId",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "serviceId",
                        name: "Service Id",
                        fieldName: "serviceId",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "serviceDescription",
                        name: "Service Description",
                        fieldName: "serviceDescription",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "commissionDate",
                        name: "Commission Date",
                        fieldName: "commissionDate",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                    ]
                    : [
                      {
                        key: "orderId",
                        name: "Order Id",
                        fieldName: "orderId",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "serviceId",
                        name: "Service Id",
                        fieldName: "serviceId",
                        minWidth: 150,
                        maxWidth: 200,
                        isResizable: true,
                      },
                      {
                        key: "serviceDescription",
                        name: "Service Description",
                        fieldName: "serviceDescription",
                        minWidth: 300,
                        maxWidth: 500,
                        isResizable: true,
                      },
                      {
                        key: "commissionDate",
                        name: "Commission Date",
                        fieldName: "commissionDate",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "datacenterId",
                        name: "Datacenter Name",
                        fieldName: "datacenterId",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                    ]
                }
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Service Details Found for this Customer"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deleteSd(
                    state.manageActionsCallout.data as IServiceDetails,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageAcDialog.isOpen && (
        <ManageSdDialog
          data={state.manageAcDialog.data}
          handleLoading={handleLoading}
          handleDialogClose={(data: IServiceDetails) => handleDialogClose(data)}
          customerId={params.customerId}
          allDatacenterDropdown={state.allDatacenterDropdown}
        />
      )}
    </React.Fragment>
  );
};

export default ServiceDetails;
